
import { locale } from './globals.js';
import { insertAfter } from './toolbox.js';

class HeroSlider {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    if(this.el.children.length < 2) {
      return;
    };
    this.rtl = (locale.dir == 'rtl');
    this.initSliders();
    this.initPager();
  }
  initSliders () {
    this.slider = new Flickity(this.el, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      rightToLeft: this.rtl,
      autoPlay: 5000
    });
  }
  initPager () {
    let pager = document.createElement('div');
    pager.classList.add('pager-arrows');
    pager.innerHTML = `${this.pagerButton('prev')}${this.pagerButton('next')}`;
    insertAfter(pager, this.el.querySelector('.flickity-viewport'));
    pager.querySelector('.arrow.prev').addEventListener('click', () => {
      this.slider.previous();
    });
    pager.querySelector('.arrow.next').addEventListener('click', () => {
      this.slider.next();
    });
  }
  pagerButton (dir) {
    return `<button type="button" class="custom arrow ${dir}" data-pager="prev"> <i class="fal fa-chevron-circle-${locale[dir]} icon"> </i></button>`
  }
  
}
export default function () {
  new HeroSlider(document.querySelector('[data-hero-slider]'));
}
